/**
 * 目录查询路由信息
 */
export default {
  name: 'directory',
  path: 'directory',
  component: resolve => require(['../../components/pages/directory/index'], resolve),
  children: [{
    name: 'Master',
    path: 'masterMainland',
    component: resolve => require(['../../components/pages/directory/masterMainland/index'], resolve),
    redirect: 'masterMainland/list',
    children: [{
      path: 'list',
      component: resolve => require(['../../components/pages/directory/masterMainland/list'], resolve)
    }, {
      path: 'search/:majorName',
      props: true,
      component: resolve => require(['../../components/pages/directory/masterMainland/search'], resolve)
    }]
  }, {
    name: 'MasterGAT',
    path: 'masterGAT',
    component: resolve => require(['../../components/pages/directory/masterGAT/index'], resolve),
    redirect: 'masterGAT/list',
    children: [{
      path: 'list',
      component: resolve => require(['../../components/pages/directory/masterGAT/list'], resolve)
    }, {
      path: 'search/:majorName',
      props: true,
      component: resolve => require(['../../components/pages/directory/masterGAT/search'], resolve)
    }]
  }, {
    name: 'DoctorMainland',
    path: 'doctorMainland',
    component: resolve => require(['../../components/pages/directory/doctorMainland/index'], resolve),
    redirect: 'doctorMainland/list',
    children: [{
      path: 'list',
      component: resolve => require(['../../components/pages/directory/doctorMainland/list'], resolve)
    }, {
      path: 'search/:majorName',
      props: true,
      component: resolve => require(['../../components/pages/directory/doctorMainland/search'], resolve)
    }]
  }, {
    name: 'DoctorGAT',
    path: 'doctorGAT',
    component: resolve => require(['../../components/pages/directory/doctorGAT/index'], resolve),
    redirect: 'doctorGAT/list',
    children: [{
      path: 'list',
      component: resolve => require(['../../components/pages/directory/doctorGAT/list'], resolve)
    }, {
      path: 'search/:majorName',
      props: true,
      component: resolve => require(['../../components/pages/directory/doctorGAT/search'], resolve)
    }]
  }]
}



// WEBPACK FOOTER //
// ./src/router/pages/directory.js